import Big from "big.js";
import { get } from "lodash";
export function useSum(values, key) {
    return (values ?? []).reduce((acc, curr)=>acc.plus((key && typeof curr === 'object' ? get(curr, key) : curr) ?? 0), Big(0)).toNumber();
}

//# sourceMappingURL=useSum.js.map